import React, { CSSProperties, FC, PropsWithChildren } from 'react';

import './ObjectDetailPage.css';

import Header, { HeaderProps } from '@web-platform/page-header';

import Footer, { IFooterProps } from './Footer';

export const OBJECTDETAILPAGE_OBJECTTYPE = {
  EXPERIMENT: 'experiment',
  VARIABLE: 'variable',
} as const;

export type ObjectDetailPage_ObjectTypeKeys =
  keyof typeof OBJECTDETAILPAGE_OBJECTTYPE;

type ObjectDetailPage = {
  id?: string;
  style?: CSSProperties;
  className?: string;
} & HeaderProps &
  IFooterProps;

export const ObjectDetailPage: FC<PropsWithChildren<ObjectDetailPage>> = ({
  children,
  id,
  style,
  className,
  icon,
  breadcrumbs,
  descriptionLabel,
  description,
  tags,
  headerTags,
  primaryActions,
  secondaryActions,
  infos,
  footer,
  onBack,
}) => {
  return (
    <div
      id={id}
      className={className}
      style={{
        ...style,
        height: '100%',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Header
        icon={icon}
        breadcrumbs={breadcrumbs}
        headerTags={headerTags}
        descriptionLabel={descriptionLabel}
        description={description}
        tags={tags}
        primaryActions={primaryActions}
        secondaryActions={secondaryActions}
        infos={infos}
        onBack={onBack}
      />
      <div
        data-test-id="objectDetailPage-content"
        className="grab-x__objectDetailPage-content-container"
      >
        {children}
      </div>
      <Footer footer={footer} />
    </div>
  );
};
